{
  "about": {
    "title": "Sobre o Spring Boot Admin",
    "label": "Sobre"
  }
}
